export default "__VITE_ASSET__cfc2ccea__"